import { memo } from 'react';

const ThoughtBubbleIcon = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="17"
		height="17"
		fill="none"
		viewBox="0 0 17 17"
	>
		<circle cx="8.844" cy="8.5" r="8" fill="#A8ACC1"></circle>
		<path
			fill="#fff"
			d="M8.021 11.093q.014-.845.176-1.364t.461-.838.805-.617q.43-.26.689-.662a1.64 1.64 0 0 0 .26-.91q0-.428-.202-.76a1.3 1.3 0 0 0-.558-.506 1.76 1.76 0 0 0-.786-.175q-.39 0-.728.156-.337.155-.565.5t-.266.85H6.125q.038-.765.41-1.331.37-.566.98-.864t1.35-.299q.807 0 1.417.319.61.318.941.883.332.565.332 1.28 0 .74-.332 1.285-.33.546-.954.936a2.6 2.6 0 0 0-.65.52 1.8 1.8 0 0 0-.35.649 3.5 3.5 0 0 0-.13.948v.065H8.02zm.598 2.793a.843.843 0 0 1-.416-1.565.83.83 0 0 1 .832 0q.195.11.305.305a.83.83 0 0 1 0 .831.84.84 0 0 1-.721.429"
		></path>
	</svg>
);

export default memo(ThoughtBubbleIcon);
